import { gql } from "@apollo/client";

export const DELETE_INVOICE_UPLOAD_DOCUMENT = gql`
  mutation deleteInvoiceUploadDocument($input: DeleteUploadDocumentInput!) {
    documentHandler {
      deleteInvoiceUploadDocument(input: $input) {
        success
      }
    }
  }
`;
